import SinglePage from '@dex/bubl-dash/src/lib/pages/SinglePage';
import ShopPayoutSingleView from './Components/ShopPayoutSingleView';
import ShopPayoutSingleEdit from './Components/ShopPayoutSingleEdit';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "View",
        zone: settings.zone,
        path: settings.key + "/:id/view",
        caps: settings.viewCaps,
        component: SinglePage,
        componentProps: {
            getFetch: settings.singleFetch,
            getFetchParams: settings.singleFetchParams,
            header: {
                getTitle: settings.singleTitle,
                getTabs: settings.singleTabs
            },
            page: ShopPayoutSingleView,
        },
    });

}